import type { MaybePromise } from "@mdotm/utils/promise";
import type { BaseSyntheticEvent } from "react";
import { Controller, type UseFormReturn, type FieldValues } from "react-hook-form";

export const FormController = Controller;

export function rejectOnInvalid<TValues extends FieldValues>(
	form: UseFormReturn<TValues, any, any>,
	submitHandler: (values: TValues) => Promise<void>,
): () => Promise<void> {
	return () =>
		new Promise((resolve, reject) => {
			form.handleSubmit(submitHandler, reject)().then(resolve, reject);
		});
}
export function handleSubmitToCustomSubmitHandler<T>({
	baseSubmitFn, handleSubmit, onInvalid,
}: {
	baseSubmitFn: (values: T) => MaybePromise<void>;
	onInvalid?: (err: any) => void;
	handleSubmit: (
		baseSubmitFn: (values: T) => MaybePromise<void>,
		onInvalid: (err: any) => void
	) => (e?: BaseSyntheticEvent) => Promise<void>;
}): (e?: BaseSyntheticEvent) => Promise<void> {
	return (e) => new Promise<void>((resolve, reject) => {
		handleSubmit(baseSubmitFn, (errors) => {
			onInvalid?.(errors);
			reject(errors);
		})(e).then(resolve, reject);
	});
}